import { render, staticRenderFns } from "./ProductEdit.vue?vue&type=template&id=a2d79930"
import script from "./ProductEdit.vue?vue&type=script&lang=ts"
export * from "./ProductEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2d79930')) {
      api.createRecord('a2d79930', component.options)
    } else {
      api.reload('a2d79930', component.options)
    }
    module.hot.accept("./ProductEdit.vue?vue&type=template&id=a2d79930", function () {
      api.rerender('a2d79930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/ProductEdit.vue"
export default component.exports